/**
 * Created by charnjeetelectrovese@gmail.com on 6/29/2020.
 */

import {
    FETCH_NEXT,
    FETCH_INIT,
    FETCHED,
    FILTER,
    RESET_FILTER,
    SET_SORTING,
    SET_FILTER,
    SET_PAGE,
    CHANGE_PAGE,
    CHANGE_STATUS,
    SET_SERVER_PAGE,
    CREATE_DATA,
    UPDATE_DATA,
    CLEAN_LIST, UPDATE_STATUS,
    LEAD_NOTES_GET_DONE,
    LEAD_NOTES_GET_INIT,
    LEAD_REQUESTS_GET_DONE,
    LEAD_REQUESTS_GET_INIT,
    LEAD_DETAIL_INIT,
    LEAD_DETAIL_DONE, CHANGE_LEAD_STATUS, CHANGE_LEAD_PRIORITY, CHANGE_LEAD_REQUEST_STATUS, ADD_LEAD_NOTES, ASSIGN_LEAD,
    SET_LEAD_REQUEST_TYPE,
    UPDATE_LEADFORM_DATA
} from '../actions/Lead.action';
import Constants from '../config/constants';

function mapPresetPRequest(all, pageId) {
    return all.filter((val, index) => {
        if (index >= (((pageId + 1) * Constants.DEFAULT_PAGE_VALUE) - Constants.DEFAULT_PAGE_VALUE) && index < (((pageId + 1) * Constants.DEFAULT_PAGE_VALUE))) {
            return val;
        }
    });
}

const initialState = {
    all: [],
    present: [], //
    currentPage: 0,
    serverPage: 0,
    query: null, // search text data
    query_data: null, // popover filter data change
    sorting_data: {row: null, order: null},
    is_fetching: false,
    batch_id: null,
    is_lead_detail: false,
    lead_detail: null,
    is_lead_requests: false,
    lead_requests: [],
    is_lead_notes: false,
    lead_notes: [],
    type: 'ALL',
};

export default function (state = JSON.parse(JSON.stringify(initialState)), action) {
    switch (action.type) {
        case CLEAN_LIST: {
            return { ...state, ...JSON.parse(JSON.stringify(initialState)) };
        }
        case FETCH_INIT: {
            return {...state, is_fetching: true};
        }

        case FETCHED: {
            const newData = (action.payload).data;
            const page = action.payload.page;
            let newAll = [];
            if (page == 1) {
                newAll = [...newData];
            } else {
                newAll = [...state.all, ...newData];
            }
            const tableData = mapPresetPRequest(newAll, state.currentPage);
            return {...state, all: newAll, present: tableData, is_fetching: false}; // { ...state , all: newAll, present: tableData, serverPage: 1, currentPage: 1 };
        }
        case SET_SORTING: {
            return {...state, sorting_data: action.payload};
        }
        case SET_LEAD_REQUEST_TYPE: {
            return {
                ...state,
                type: action.payload
            };
        }
        case UPDATE_STATUS: {
            if (action.payload) {
                let tempIndex = null;
                const prevState = state.all;
                prevState.some((val, index) => {
                    if (val.id == action.payload.id) {
                        tempIndex = index;
                        return true;
                    }
                });
                if (tempIndex != null) {
                    prevState[tempIndex].status = action.payload.status
                }
                // const newState = state.all.map((val) => {
                //     if (val.id == action.payload.id) {
                //         return { ...val, status: action.payload.status == 'SUSPEND' ? 'SUSPEND' : 'ACTIVE' };
                //     } return { ...val };
                // });
                const tableData = mapPresetPRequest(prevState, state.currentPage);
                return {...state, all: prevState, present: tableData};
            }
            return state;
        }
        case CHANGE_STATUS: {
            if (action.payload) {
                let tempIndex = null;
                const prevState = state.all;
                prevState.some((val, index) => {
                    if (val.id == action.payload) {
                        tempIndex = index;
                        return true;
                    }
                });
                if (tempIndex != null) {
                    prevState.splice(tempIndex, 1);
                }
                // const newState = state.all.map((val) => {
                //     if (val.id == action.payload.id) {
                //         return { ...val, status: action.payload.status == 'SUSPEND' ? 'SUSPEND' : 'ACTIVE' };
                //     } return { ...val };
                // });
                const tableData = mapPresetPRequest(prevState, state.currentPage);
                return {...state, all: prevState, present: tableData};
            }
            return state;
        }
        // case NEX: {
        //     const tableData = mapPresetPRequest(state.all, state.currentPage + 1);
        //     return { ...state, present: tableData, currentPage: (state.currentPage + 1) };
        // }
        // case PREV_PREQUESTS: {
        //     const tableData = mapPresetPRequest(state.all, state.currentPage - 1);
        //     return { ...state, present: tableData, currentPage: (state.currentPage - 1) };
        // }
        case CHANGE_PAGE: {
            const tempPage = action.payload;
            const tableData = mapPresetPRequest(state.all, tempPage);
            return {...state, present: tableData, currentPage: tempPage};
        }
        case FETCH_NEXT: {
            const newAll = state.all.concat(action.payload);
            return {...state, all: newAll, serverPage: (state.serverPage + 1)};
        }
        case FILTER: {
            return {...state, present: action.payload};
        }
        case SET_FILTER: {
            return {...state, query: action.payload.query, query_data: action.payload.query_data};
        }
        case RESET_FILTER: {
            const tableData = mapPresetPRequest(state.all, state.currentPage);
            return {...state, present: tableData};
        }
        case SET_PAGE: {
            return {...state, currentPage: action.payload};
        }
        case SET_SERVER_PAGE: {
            return {...state, serverPage: action.payload};
        }

        case CREATE_DATA: {
            if (action.payload) {
                const prevState = state.all;
                prevState.unshift(action.payload);
                const tableData = mapPresetPRequest(prevState, state.currentPage);
                return {...state, all: prevState, present: tableData};
            }
            return state;
        }
        case UPDATE_DATA: {
            if (action.payload) {
                const prevState = state.all;
                let tIndex = null;
                prevState.some((val, index) => {
                    if (val.id == action.payload.id) {
                        tIndex = index;
                        return true;
                    }
                });
                if (tIndex != null) {
                    const newData = action.payload;
                    const oldData = prevState[tIndex];
                    if (newData.type == 'STATUS_UPDATE') {
                        const timeStamps = oldData.timestamps;
                        timeStamps[newData.status] = newData.current_timestamp;
                        newData.timestamps = timeStamps;
                    }
                    prevState[tIndex] = {
                        ...oldData,
                        ...newData,
                    };
                }
                const tableData = mapPresetPRequest(prevState, state.currentPage);
                return {...state, all: prevState, present: tableData};
            }
            return state;
        }

        case LEAD_DETAIL_INIT: {
            return {
                ...state,
                is_lead_detail: true
            }
        }
        case LEAD_DETAIL_DONE: {
            return {
                ...state,
                is_lead_detail: false,
                lead_detail: action.payload
            }
        }
        case UPDATE_LEADFORM_DATA: {
            if(state.lead_detail){
                const tempData = JSON.parse(JSON.stringify(state.lead_detail));
                tempData.user = {...tempData.user,...action.payload}
                return {
                    ...state,
                    lead_detail: tempData
                }
            }
        }
        case LEAD_REQUESTS_GET_INIT: {
            return {
                ...state,
                is_lead_requests: true
            }
        }
        case LEAD_REQUESTS_GET_DONE: {
            return {
                ...state,
                is_lead_requests: false,
                lead_requests: action.payload.reverse()
            }
        }case LEAD_NOTES_GET_INIT: {
            return {
                ...state,
                is_lead_notes: true
            }
        }
        case LEAD_NOTES_GET_DONE: {
            return {
                ...state,
                is_lead_notes: false,
                lead_notes: action.payload
            }
        }
        case CHANGE_LEAD_STATUS: {
            if (state.lead_detail) {
                const tempData = JSON.parse(JSON.stringify(state.lead_detail));
                tempData.status = action.payload;
                return {
                    ...state,
                    lead_detail: tempData,
                };
            }
            return {
                ...state,
            };
        }
        case CHANGE_LEAD_PRIORITY: {
            if (state.lead_detail) {
                const tempData = JSON.parse(JSON.stringify(state.lead_detail));
                tempData.priority = action.payload;
                return {
                    ...state,
                    lead_detail: tempData,
                };
            }
            return {
                ...state,
            };
        }

        case CHANGE_LEAD_REQUEST_STATUS: {
            const temp = JSON.parse(JSON.stringify(state.lead_requests));
            const index = temp.findIndex(val => val.request_id == action.payload.request_id);
            if (index >= 0) {
                temp[index].status = action.payload.status;
            }
            return {
                ...state,
                lead_requests: temp,
            };
        }

        case ADD_LEAD_NOTES: {
            const temp = JSON.parse(JSON.stringify(state.lead_notes));
            temp.unshift(action.payload);

            return {
                ...state,
                lead_notes: temp,
            };
        }
        case ASSIGN_LEAD: {
            return {
                ...state,
                lead_detail: action.payload,
            }
        }
        default: {
            return state;
        }
    }
}
